export default __webpack_public_path__ + "static/media/28.941d0985.jpg";